export enum ExternalLoyaltyEndpoints {
  CalculateExternalLoyaltyV1 = 'CalculateExternalLoyaltyV1',
  GetLoyaltyCardsByLeadIdV1 = 'GetLoyaltyCardsByLeadIdV1',
  GetLoyaltyCardsBySerialNumberV1 = 'GetLoyaltyCardsBySerialNumberV1',
}

export enum LoyaltyCardType {
  Discount = 'discount',
  Bonus = 'bonus',
}

export interface LoyaltyCard {
  id: string;
  number: string;
  name: string;
  level: string;
  bonuses: number;
  discount: number;
  type: LoyaltyCardType;
  created_at: string;
}

export interface ExternalLoyaltyCalculateItem {
  product_id: string;
  price: number;
  quantity: number;
  paid: number;
}

export interface CalculateExternalLoyaltyV1Request {
  card_id: string;
  items: ExternalLoyaltyCalculateItem[];
  bonuses_to_exceed?: number;
  external_order_id?: string;
}

export interface CalculateExternalLoyaltyV1Response {
  calculation_id: string;
  total_amount: number;
  max_bonuses_to_exceed: number;
  bonuses_to_exceed: number;
  bonuses_to_earn: number;
  final_amount: number;
  discount_amount: number;
  message: string;
  items: Array<
    ExternalLoyaltyCalculateItem & {
      extra: Array<{ discount: number; bonuses: number }>;
    }
  >;
}

export interface GetLoyaltyCardsByLeadIdV1Request {
  byhelp_lead_id: number;
  byhelp_client_id: number;
}

export interface GetLoyaltyCardsByLeadIdV1Response {
  cards: LoyaltyCard[];
}

export interface GetLoyaltyCardsBySerialNumberV1Request {
  serialNumber: string;
}

export interface GetLoyaltyCardsBySerialNumberV1Response {
  cards: LoyaltyCard[];
}
